"use strict";
class ChatWidget {
    constructor(config = {}) {
        this.isOpen = false;
        this.sessionToken = null;
        this.isShopifyEmbedded = false;
        this.customerContext = {};
        this.config = config;
        this.customerContext = config.customerContext || {};
        // Detect if we're running in Shopify admin (embedded app)
        this.isShopifyEmbedded = this.detectShopifyEnvironment();
        // Set API URL based on config or environment
        if (config.apiUrl) {
            this.apiUrl = config.apiUrl;
        }
        else {
            const isLocal = window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1' ||
                window.location.protocol === 'file:';
            this.apiUrl = isLocal
                ? 'http://localhost:3000'
                : 'https://denimsamurai-production.up.railway.app';
        }
        this.conversationId = this.generateConversationId();
        // Initialize session token if in Shopify environment
        if (this.isShopifyEmbedded) {
            this.initializeShopifyIntegration();
        }
        this.createChatStructure();
        this.initializeElements();
        this.bindEvents();
        this.hideBadge();
    }
    detectShopifyEnvironment() {
        // Check if we're in Shopify admin iframe
        return window.top !== window.self &&
            (window.location.hostname.includes('shopify.com') ||
                document.referrer.includes('shopify.com') ||
                window.parent !== window);
    }
    async initializeShopifyIntegration() {
        try {
            console.log('🔍 Initializing Shopify App Bridge integration...');
            // Try to get session token from Shopify App Bridge
            const windowAny = window;
            if (windowAny.app && typeof windowAny.app.getSessionToken === 'function') {
                this.sessionToken = await windowAny.app.getSessionToken();
                console.log('✅ Session token obtained from App Bridge');
            }
            else if (windowAny.shopifyAppBridge) {
                // Alternative App Bridge access
                this.sessionToken = await windowAny.shopifyAppBridge.getSessionToken();
                console.log('✅ Session token obtained from shopifyAppBridge');
            }
            else {
                console.log('⚠️ App Bridge not found, checking for manual session token...');
                // Try to get from URL params or other sources
                this.sessionToken = this.getSessionTokenFromUrl();
            }
        }
        catch (error) {
            console.error('❌ Failed to initialize Shopify integration:', error);
            this.isShopifyEmbedded = false;
        }
    }
    getSessionTokenFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('session') || urlParams.get('sessionToken') || null;
    }
    createChatStructure() {
        const containerId = this.config.containerId || 'dearborn-chat-widget';
        let targetContainer = document.getElementById(containerId);
        if (!targetContainer) {
            // Create container if it doesn't exist
            targetContainer = document.createElement('div');
            targetContainer.id = containerId;
            document.body.appendChild(targetContainer);
        }
        // Apply main widget class
        targetContainer.className = 'dearborn-chat-widget';
        // Create the chat widget HTML structure
        targetContainer.innerHTML = `
            <div id="dearborn-chat-toggle" class="dearborn-chat-toggle">
                <div class="dearborn-chat-icon">💬</div>
                <div id="dearborn-chat-badge" class="dearborn-chat-badge" style="display: none;">1</div>
            </div>
            
            <div id="dearborn-chat-window" class="dearborn-chat-window">
                <div class="dearborn-chat-header">
                    <div class="dearborn-chat-title">
                        <h3>Denim Samurai AI</h3>
                        <div class="dearborn-chat-subtitle">Premium American Denim Expert</div>
                    </div>
                    <button id="dearborn-chat-close" class="dearborn-chat-close">×</button>
                </div>
                
                <div id="dearborn-chat-messages" class="dearborn-chat-messages">
                    <div class="dearborn-message assistant">
                        <div class="dearborn-message-content">
                            👋 Hi! I'm your personal denim expert. I can help you find the perfect Dearborn jeans, answer sizing questions, and share care tips. What can I help you with today?
                        </div>
                        <div class="dearborn-message-time">Just now</div>
                    </div>
                </div>
                
                <div id="dearborn-typing-indicator" class="dearborn-typing-indicator">
                    <div class="dearborn-typing-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                
                <div class="dearborn-chat-input-container">
                    <input 
                        type="text" 
                        id="dearborn-chat-input" 
                        class="dearborn-chat-input" 
                        placeholder="Ask about our denim, sizing, care tips..." 
                        maxlength="500"
                    >
                    <button id="dearborn-chat-send" class="dearborn-chat-send" type="button">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z"/>
                        </svg>
                    </button>
                </div>
            </div>
        `;
    }
    initializeElements() {
        // Find elements after creating the structure
        const toggle = document.getElementById('dearborn-chat-toggle');
        const chatWindow = document.getElementById('dearborn-chat-window');
        const messagesContainer = document.getElementById('dearborn-chat-messages');
        const input = document.getElementById('dearborn-chat-input');
        const sendButton = document.getElementById('dearborn-chat-send');
        const typingIndicator = document.getElementById('dearborn-typing-indicator');
        const badge = document.getElementById('dearborn-chat-badge');
        if (!toggle || !chatWindow || !messagesContainer || !input || !sendButton || !typingIndicator || !badge) {
            throw new Error('❌ Failed to initialize chat widget: Required DOM elements not found');
        }
        this.container = chatWindow;
        this.toggle = toggle;
        this.messagesContainer = messagesContainer;
        this.input = input;
        this.sendButton = sendButton;
        this.typingIndicator = typingIndicator;
        this.badge = badge;
    }
    bindEvents() {
        this.toggle.addEventListener('click', () => this.toggleChat());
        const closeButton = document.getElementById('dearborn-chat-close');
        closeButton.addEventListener('click', () => this.closeChat());
        this.sendButton.addEventListener('click', () => this.sendMessage());
        this.input.addEventListener('keypress', (e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                this.sendMessage();
            }
        });
        this.input.addEventListener('input', () => {
            this.sendButton.style.opacity = this.input.value.trim() ? '1' : '0.5';
        });
    }
    generateConversationId() {
        return 'chat_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }
    toggleChat() {
        if (this.isOpen) {
            this.closeChat();
        }
        else {
            this.openChat();
        }
    }
    openChat() {
        const chatWindow = document.getElementById('dearborn-chat-window');
        if (chatWindow) {
            chatWindow.classList.add('open');
            this.toggle.classList.add('open');
        }
        this.isOpen = true;
        this.hideBadge();
        // Focus input after animation
        setTimeout(() => {
            this.input.focus();
        }, 300);
    }
    closeChat() {
        const chatWindow = document.getElementById('dearborn-chat-window');
        if (chatWindow) {
            chatWindow.classList.remove('open');
            this.toggle.classList.remove('open');
        }
        this.isOpen = false;
    }
    showBadge() {
        this.badge.style.display = 'flex';
    }
    hideBadge() {
        this.badge.style.display = 'none';
    }
    async sendMessage() {
        const message = this.input.value.trim();
        if (!message)
            return;
        // Clear input and disable send button
        this.input.value = '';
        this.sendButton.style.opacity = '0.5';
        // Add user message to chat
        this.addMessage('user', message);
        // Show typing indicator
        this.showTypingIndicator();
        try {
            // Refresh session token if needed
            if (this.isShopifyEmbedded && !this.sessionToken) {
                await this.initializeShopifyIntegration();
            }
            // Get customer context (you can enhance this)
            const customerContext = this.getCustomerContext();
            // Prepare headers
            const headers = {
                'Content-Type': 'application/json',
            };
            // Add session token for Shopify authentication
            if (this.sessionToken) {
                headers['Authorization'] = `Bearer ${this.sessionToken}`;
                console.log('🔐 Including session token in API request');
            }
            else if (this.isShopifyEmbedded) {
                console.warn('⚠️ No session token available for Shopify embedded app');
            }
            const response = await fetch(`${this.apiUrl}/api/chat`, {
                method: 'POST',
                headers,
                body: JSON.stringify({
                    message,
                    conversationId: this.conversationId,
                    customerContext,
                    isShopifyEmbedded: this.isShopifyEmbedded
                }),
            });
            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('Authentication failed. Please refresh the page and try again.');
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            // Hide typing indicator and add bot response
            this.hideTypingIndicator();
            this.addMessage('assistant', data.response);
        }
        catch (error) {
            console.error('Chat error:', error);
            this.hideTypingIndicator();
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            if (errorMessage.includes('Authentication failed')) {
                this.addMessage('assistant', 'Authentication expired. Please refresh the page to continue chatting.');
            }
            else {
                this.addMessage('assistant', 'Sorry, I encountered an error. Please try again or contact our support team.');
            }
        }
    }
    addMessage(role, content) {
        const messageDiv = document.createElement('div');
        messageDiv.className = `dearborn-message ${role}`;
        const contentDiv = document.createElement('div');
        contentDiv.className = 'dearborn-message-content';
        // For assistant messages, allow HTML links to be rendered
        // For user messages, keep as text to prevent XSS
        if (role === 'assistant') {
            // Sanitize content but allow safe HTML like links
            contentDiv.innerHTML = this.sanitizeHTML(content);
        }
        else {
            contentDiv.textContent = content;
        }
        const timeDiv = document.createElement('div');
        timeDiv.className = 'dearborn-message-time';
        timeDiv.textContent = this.formatTime(new Date());
        messageDiv.appendChild(contentDiv);
        messageDiv.appendChild(timeDiv);
        this.messagesContainer.appendChild(messageDiv);
        this.scrollToBottom();
        // Show badge if chat is closed and it's a bot message
        if (!this.isOpen && role === 'assistant') {
            this.showBadge();
        }
    }
    showTypingIndicator() {
        this.typingIndicator.classList.add('show');
        this.scrollToBottom();
    }
    hideTypingIndicator() {
        this.typingIndicator.classList.remove('show');
    }
    scrollToBottom() {
        setTimeout(() => {
            this.messagesContainer.scrollTop = this.messagesContainer.scrollHeight;
        }, 100);
    }
    formatTime(date) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    getCustomerContext() {
        // This function can be enhanced to gather more context
        // For Shopify integration, you could include:
        // - Current product being viewed
        // - Cart contents
        // - Customer login status
        // - Previous orders
        return {
            userAgent: navigator.userAgent,
            currentUrl: window.location.href,
            timestamp: new Date().toISOString(),
            isShopifyEmbedded: this.isShopifyEmbedded,
            hasSessionToken: !!this.sessionToken
            // Add Shopify-specific context here when integrating
        };
    }
    sanitizeHTML(html) {
        // Create a temporary div to parse HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        // Get all elements and check if they're allowed
        const allowedTags = ['a', 'br', 'strong', 'em', 'b', 'i'];
        const allowedAttributes = ['href', 'target', 'rel'];
        // Function to recursively clean elements
        const cleanElement = (element) => {
            if (allowedTags.includes(element.tagName.toLowerCase())) {
                let result = `<${element.tagName.toLowerCase()}`;
                // Add allowed attributes
                for (let i = 0; i < element.attributes.length; i++) {
                    const attr = element.attributes[i];
                    if (allowedAttributes.includes(attr.name.toLowerCase())) {
                        // Ensure href is safe
                        if (attr.name.toLowerCase() === 'href') {
                            if (attr.value.startsWith('https://dearborndenim.us') ||
                                attr.value.startsWith('mailto:') ||
                                attr.value.startsWith('/collections/') ||
                                attr.value.startsWith('/products/')) {
                                result += ` ${attr.name}="${attr.value}"`;
                                // Add target="_blank" for external links
                                if (attr.value.startsWith('https://')) {
                                    result += ' target="_blank" rel="noopener noreferrer"';
                                }
                            }
                        }
                        else {
                            result += ` ${attr.name}="${attr.value}"`;
                        }
                    }
                }
                result += '>';
                // Process children
                for (const child of Array.from(element.childNodes)) {
                    if (child.nodeType === Node.TEXT_NODE) {
                        result += child.textContent || '';
                    }
                    else if (child.nodeType === Node.ELEMENT_NODE) {
                        result += cleanElement(child);
                    }
                }
                result += `</${element.tagName.toLowerCase()}>`;
                return result;
            }
            else {
                // For non-allowed tags, just return the text content
                return element.textContent || '';
            }
        };
        let result = '';
        for (const child of Array.from(tempDiv.childNodes)) {
            if (child.nodeType === Node.TEXT_NODE) {
                result += child.textContent || '';
            }
            else if (child.nodeType === Node.ELEMENT_NODE) {
                result += cleanElement(child);
            }
        }
        return result;
    }
    // Public method to update session token from external code
    setSessionToken(token) {
        this.sessionToken = token;
        this.isShopifyEmbedded = true;
        console.log('✅ Session token updated in chat widget');
    }
    // Public method to refresh session token
    async refreshSessionToken() {
        if (this.isShopifyEmbedded) {
            await this.initializeShopifyIntegration();
        }
    }
    // Public methods for external access
    open() {
        this.openChat();
    }
    close() {
        this.closeChat();
    }
    isVisible() {
        return this.isOpen;
    }
    // Public method for testing link rendering
    testLinkRendering() {
        const messageWithLinks = `Check out our <a href="https://dearborndenim.us/collections/tailored-fit" target="_blank">Tailored Fit Jeans</a> and <a href="https://dearborndenim.us/collections/belts" target="_blank">Premium Leather Belts</a> for a complete look!`;
        this.addMessage('assistant', messageWithLinks);
        this.open();
    }
}
// Initialize chat widget when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new ChatWidget();
});
// Export for potential external use
window.ChatWidget = ChatWidget;
//# sourceMappingURL=chat-widget.js.map